// Toast แจ้งเตือนมุมขวาบน — framework-free
export type ToastType = "info" | "error" | "success";

let stack: HTMLElement | null = null;

function ensureStack(): HTMLElement {
  if (!stack || !stack.isConnected) {
    stack = document.createElement("div");
    stack.className = "toast-stack";
    document.body.appendChild(stack);
  }
  return stack;
}

export function toast(message: string, type: ToastType = "info", ms = 3600): void {
  const el = document.createElement("div");
  el.className = `toast${type === "error" ? " toast-error" : type === "success" ? " toast-success" : ""}`;
  el.setAttribute("role", type === "error" ? "alert" : "status");
  el.textContent = message;
  el.addEventListener("click", dismiss);

  ensureStack().appendChild(el);
  requestAnimationFrame(() => el.classList.add("show"));

  const timer = window.setTimeout(dismiss, ms);
  function dismiss() {
    window.clearTimeout(timer);
    el.classList.remove("show");
    window.setTimeout(() => el.remove(), 240);
  }
}
